import React from 'react';
import { Label, OverlayTrigger, Popover } from 'react-bootstrap'

class PingStatus extends React.Component {
    render() {
        if (this.props.processing)
            return (<Label bsStyle="info">Processing...</Label>);

        if (this.props.pingError === null)
            return (<Label bsStyle="success">Service OK</Label>);

        if (this.props.pingError !== undefined) {
            const popover = (
                <Popover id="popover-trigger-hover-focus" title="Error Description">
                    <strong>{this.props.pingError.errorMessage}</strong><br />
                    <small>{this.props.pingError.errorDetail}</small>
                </Popover>
            );
            
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popover}>
                    <Label bsStyle="danger">ERROR</Label>
                </OverlayTrigger>);
        }

        return null;
    }
}

export default PingStatus;


// WEBPACK FOOTER //
// ./src/areas/admin/console/services/PingStatus.js